import {FC, useEffect, useRef, useState} from 'react';
import {Chip, Grid} from '@material-ui/core';

interface CCInputProps {
    initialEmails: string[];
    type: 'To' | 'From' | 'BCC';
    setEmails?: (emails: string[]) => void;
}

export const CCInput: FC<CCInputProps> = ({initialEmails, type, setEmails}) => {
    const [items, setItems] = useState<string[]>(initialEmails);
    const [value, setValue] = useState('');
    const [error, setError] = useState<string | null>('');

    const input = useRef<HTMLInputElement>(null);

    useEffect(() => {
        setEmails?.(items);
    }, [items.length]);

    const handleKeyDown = (evt: any) => {
        if (['Enter', 'Tab', ',', ' '].includes(evt.key)) {
            evt.preventDefault();

            const v = value.trim();

            if (value && isValid(v)) {
                setValue('');
                setItems([...items, v]);
            }
        }
    };

    const handleChange = (evt: any) => {
        setValue(evt.target.value);
        setError(null);
    };

    const handleDelete = (item: any) => {
        setItems(items.filter((i) => i !== item));
    };

    const handlePaste = (evt: any) => {
        evt.preventDefault();

        let paste = evt.clipboardData.getData('text');
        let emails = paste.match(/[\w\d\.-]+@[\w\d\.-]+\.[\w\d\.-]+/g);

        if (emails) {
            let toBeAdded = emails.filter((email: string) => !isInList(email));

            setItems([...items, ...toBeAdded]);
        }
    };

    const isValid = (email: string) => {
        let error = null;

        if (isInList(email)) {
            error = `${email} has already been added.`;
        }

        if (!isEmail(email)) {
            error = `${email} is not a valid email address.`;
        }

        if (error) {
            setError(error);

            return false;
        }

        return true;
    };

    const isInList = (email: string) => {
        return items.includes(email);
    };

    const isEmail = (email: any) => {
        return /[\w\d\.-]+@[\w\d\.-]+\.[\w\d\.-]+/.test(email);
    };

    return (
        <div
            onClick={() => input?.current?.focus()}
            style={{
                display: 'flex',
                alignItems: 'flex-start',
                marginBottom: 12,
                borderBottom: '1px solid #aaa',
                maxWidth: 719,
                paddingBottom: 5,
            }}
        >
            <p style={{fontSize: 14, marginTop: 12}}>{type}:</p>
            <div style={{display: 'flex', flexWrap: 'wrap', alignItems: 'flex-start'}}>
                {items.map((item, index) => (
                    <div className="tag-item" key={item} style={{marginLeft: 5}}>
                        <Chip
                            label={item}
                            onDelete={() => handleDelete(item)}
                            style={{textOverflow: 'ellipsis', marginTop: 10}}
                            size="small"
                            disabled={type === 'From'}
                        />
                    </div>
                ))}
                <Grid>
                    <input
                        ref={input}
                        value={value}
                        onKeyDown={handleKeyDown}
                        onChange={handleChange}
                        onPaste={handlePaste}
                        disabled={type === 'From'}
                        style={{
                            backgroundColor: '#ffffff',
                            height: 25,
                            marginLeft: 5,
                            marginTop: 8,
                            border: 'none',
                            outline: 'none',
                            fontSize: 14,
                        }}
                    />
                </Grid>
            </div>
        </div>
    );
};
